import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Flex, Skeleton } from 'antd';
import dayjs from 'dayjs';

// components
import Icon from 'utils/icon';

// styles
import styles from '../../companyInformation.module.scss';

// models
import { LatestAction } from '../models/overview';
import { isRTL } from './../../../../../core/services/language';
import NoData from 'components/noData/noData';

interface LatestActionsListComponentProps {
	latestActions: LatestAction[];
	loading: boolean;
}

const LatestActionsListComponent: FunctionComponent<LatestActionsListComponentProps> = ({ latestActions, loading }) => {
	const { t } = useTranslation();

	return (
		<div className="mt-4">
			<h6 className="text-light">{t('COMPANY_INFORMATION.LATEST_TRANSACTIONS')}</h6>
			{loading ? (
				[1, 2, 3, 4, 5].map((_, index) => (
					<Skeleton.Button
						active
						block
						key={index}
						style={{
							minHeight: 82,
							borderBottom: index === 4 ? 0 : '1px solid #fff',
							borderRadius: index === 0 ? 'var(--radius) var(--radius) 0 0' : index === 4 ? '0 0 var(--radius) var(--radius)' : 0,
						}}
					/>
				))
			) : latestActions.length === 0 ? (
				<div className={`${styles.registryList} py-5`}>
					<NoData />
				</div>
			) : (
				<div className={`${styles.registryList}`}>
					{latestActions.map((action, index) => (
						<Flex justify="space-between" align="center" key={index} className={styles.registryList_item}>
							<div>
								<p className="text-light mb-0">{isRTL() ? action.title.ar : action.title.en}</p>
								<p className="mb-0"><span dir="ltr">{dayjs(action.created_at).format('DD/MM/YYYY, hh:mm A')}</span></p>
							</div>
							<Button type="link" className="p-0">
								<Icon name="copy" color="#98A2B3" />
							</Button>
						</Flex>
					))}
				</div>
			)}
		</div>
	);
};

export default LatestActionsListComponent;
